
//
// Ajax Template Notice
//
// Like Ajax Pending Notice but just awaits template data and fills out the template.
//

module.exports = function AjaxTemplateNotice ($host, config) {

  // Config
  var requestUrl = config.requestUrl;

  // Dom
  var $loading    = $('[data-loading-notice]',         $host);
  var $ready      = $('[data-ready-notice]',           $host);
  var $template   = $('[data-template]',               $host);
  var $voidButton = $('[data-void-unredeemed-button]', $host);

  // Functions
  function populate (data) {
    $template.html( fillTemplate($template.html().trim(), data) );
    $loading.hide();
    $ready.show();

    // Special functions
    //
    // Currently this widget is only used on the Campaign Sent view, so this
    // part is totally unique to this use case. If we want to re-use the AjaxTemplateNotice in some
    // other way, we should break it into different widgets, call this one AjaxCampaignSentStats,
    // and keep the case-specific stuff here. Or else add some conditional features to the template
    // function to generalise this widget to handle more cases, but that's probably a bad idea.

    // Show/hide 'Void Unredeemed' button based on voidable voucher count
    $voidButton.toggle(data.num_voidable > 0);
  }


  // Fetch
  fetchJson(requestUrl, populate, log);

  // Interface
  return { show: populate }

};
